import { LogLevel } from 'services/logger.service';
import { useAppDispatch, useAppSelector } from 'store/store-hooks';
import { getClipTime, newClip, parseClipId } from 'components/app/_helpers/_app.helper';
import { appLogger } from 'components/app/_mediator/app-logger.slice';
import { handleClips } from 'components/app/editor/_mediator/editor.slice';
import { SbPosition } from 'components/app/editor/_mediator/editor-controls.slice';
import { clipsApi } from './editor-clips.helper';
import { sbApi } from './editor-clips-sb.helper';
import { findLinkByClipTime } from './editor-clips-linking.helper';
const ERR_ID = 'use-clips-error';

export const useClipsNotFound = () => {
  const clipsMap = useAppSelector((state) => state.editor.clipsMap);
  const clipsFetchFailed = useAppSelector((state) => state.editor.clipsFetchFailed);
  const storyBoard = useAppSelector((state) => state.editor.storyBoard);
  const linkedClips = useAppSelector((state) => state.editor.linkedClips);
  const selector = useAppSelector((state) => state.editor.selector);
  const dispatch = useAppDispatch();

  return (clipId: ClipId, sbPosition: SbPosition) => {
    if (!clipsMap || !selector || clipsFetchFailed) return;
    console.error(`[${ERR_ID}]: clipData not found, attempting to recreate`, { clipId });
    dispatch(
      appLogger({
        level: LogLevel.Fatal,
        error: { name: `[${ERR_ID}]: clipData not found, attempting to recreate`, message: `clipId: ${clipId}` },
      })
    );
    const clip = newClip(parseClipId(clipId));
    clip.clipGroupId = findLinkByClipTime(getClipTime(clip), linkedClips, clip.mediaFileId) ?? 0;
    const sb = sbApi(storyBoard).removeClip(clipId, sbPosition);
    const res = clipsApi(selector, { ...storyBoard, ...sb }, linkedClips).add([clip], sbPosition);
    if (!res) {
      console.error(`[${ERR_ID}]: storyboard placement failed while recreating clip`, { clipId });
      dispatch(
        appLogger({
          level: LogLevel.Fatal,
          error: {
            name: `[${ERR_ID}]: storyboard placement failed while recreating clip`,
            message: `clipId: ${clipId}`,
          },
        })
      );
      return;
    }
    dispatch(
      handleClips({
        data: res,
        backupSkip: true,
      })
    );
  };
};
